import { Container } from "reactstrap"
import styled from "styled-components"
import { COLORS } from "../constants"
import ReactLoading from 'react-loading';

const StyledLoadingPage = styled.div`
    position: fixed;
    display: flex;
    top: 0;
    justify-content: center;
    align-items: center;
    z-index: 100;
    background-color: ${COLORS.light_blue};
    width: 100%;
    height: 100vh;
    flex-direction: column;

    opacity: ${props => props.visible ? 1 : 0};
    pointer-events: ${props => props.visible ? "all" : "none"};
    transition: all 0.2s;
    
`;
function Loading({ visible }) {
    return (
        <StyledLoadingPage visible={visible}>
            <div style={{ marginTop: "-100px" }}>
                <ReactLoading type="bubbles" color={COLORS.green} height={130} width={200} />
            </div>
        </StyledLoadingPage>
    );
}

export default Loading;